import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import ProofStats from '../components/ProofStats';
import AboutCenter from '../components/AboutCenter';
import DoctorAuthority from '../components/DoctorAuthority';
import SignatureTherapies from '../components/SignatureTherapies';
import ConditionsTreated from '../components/ConditionsTreated';
import WhyChooseUs from '../components/WhyChooseUs';
import PatientJourney from '../components/PatientJourney';
import FAQ from '../components/FAQ';
import Testimonials from '../components/Testimonials';
import FinalCTA from '../components/FinalCTA';
import SEO from '../components/SEO';
import { getTeam } from '../services/dataService';

const HomePage = () => {
  const [heroImage, setHeroImage] = useState(null);
  const [heroName, setHeroName] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const team = await getTeam();
        // Prefer primary by sortOrder, else first active
        const primary = (team || []).find(m => m.sortOrder === 1 && m.isActive) || (team || [])[0];
        if (mounted && primary) {
          setHeroImage(primary.image);
          setHeroName(primary.name);
        }
      } catch (err) {
        // ignore - keep defaults
        console.error('Failed to load team for hero image', err);
      }
    })();

    return () => { mounted = false; };
  }, []);
  return (
    <>
      <SEO
        pageType="home"
        title="Mumbai's Best Chiropractor | JIVA NADI Therapy Center | Non-Surgical Pain Relief"
        description="Mumbai's top chiropractor Dr. Saurabh Singh offers non-surgical pain relief treatments. 15+ years experience, 30,000+ successful treatments. Book appointment today!"
        keywords="chiropractor Mumbai, pain relief, non-surgical treatment, spine care, JIVA NADI, Dr. Saurabh Singh, chiropractic therapy, back pain treatment"
      />
      <Hero image={heroImage} heroTitle={"Meet Your Healing Expert"} heroName={heroName} />
      {/* <ProofStats /> */}
      <AboutCenter />
      <DoctorAuthority image={heroImage} name={heroName} />
      <SignatureTherapies />
      <ConditionsTreated />
      <WhyChooseUs />
      <PatientJourney />
      <Testimonials />
      <FinalCTA />
    </>
  );
};

export default HomePage;